// 055 — concentrado de exámenes especiales (HCU 2008, AM 000138), tabla simple de
// resultados. No figura en la HCU 2021: imprime la cita 'HCU 2008…' — ver `formularioResumenMsp.tsx`.
import { crearFormularioResumenMsp } from './formularioResumenMsp';

export const Formulario055 = crearFormularioResumenMsp({ codigo: '055', claveI18n: 'f055' });
